import { ProntuarioGeralistaData } from "../interfaces/prontuarioGeralista.interface";

export type ProntuarioGeralistaFormData = ProntuarioGeralistaData;

/**
 * Converte exames do formato do backend (com objetos) para array de strings
 */
const extractExamesSolicitados = (initialData: any): string[] => {
  if (!initialData) {
    console.log('🔍 [extractExamesSolicitados] initialData é null/undefined');
    return [];
  }
  
  console.log('🔍 [extractExamesSolicitados] Dados recebidos:', {
    hasExamesSolicitados: !!initialData.examesSolicitados,
    isArray: Array.isArray(initialData.examesSolicitados),
    length: initialData.examesSolicitados?.length,
    firstItem: initialData.examesSolicitados?.[0]
  });
  
  // Se já é um array de strings, retornar diretamente
  if (Array.isArray(initialData.examesSolicitados)) {
    // Verificar se é array de strings ou array de objetos
    if (initialData.examesSolicitados.length > 0) {
      const firstItem = initialData.examesSolicitados[0];
      if (typeof firstItem === 'string') {
        console.log('✅ [extractExamesSolicitados] Retornando array de strings:', initialData.examesSolicitados);
        return initialData.examesSolicitados;
      }
      // Se for array de objetos, extrair os nomes
      if (firstItem?.exame?.nome) {
        const nomes = initialData.examesSolicitados.map((item: any) => item.exame.nome);
        console.log('✅ [extractExamesSolicitados] Extraindo nomes dos objetos:', nomes);
        return nomes;
      }
      // Tentar acessar nome diretamente se não houver relação exame
      if (firstItem?.nome) {
        const nomes = initialData.examesSolicitados.map((item: any) => item.nome);
        console.log('✅ [extractExamesSolicitados] Extraindo nomes diretamente:', nomes);
        return nomes;
      }
    }
    console.log('⚠️ [extractExamesSolicitados] Array vazio ou formato não reconhecido');
    return [];
  }
  
  console.log('⚠️ [extractExamesSolicitados] examesSolicitados não é um array');
  return [];
};

export const getInitialData = (initialData?: Partial<ProntuarioGeralistaData> | any): ProntuarioGeralistaFormData => {
  return {
    queixaPrincipal: initialData?.queixaPrincipal ?? "",
    historiaAtual: initialData?.historiaAtual ?? "",
    historiaPatologica: initialData?.historiaPatologica ?? "",
    historiaFamiliar: initialData?.historiaFamiliar ?? "",
    alergias: initialData?.alergias ?? "",
    usaCigarros: initialData?.usaCigarros ?? false,
    usaAlcool: initialData?.usaAlcool ?? false,
    praticaExercicios: initialData?.praticaExercicios ?? false,
    examesSolicitados: extractExamesSolicitados(initialData),
    observacoes: initialData?.observacoes ?? "",
  };
};
